import { privateApi, createPrivateClient } from './api';
import type { CheckoutSessionPayload } from '../types/checkout';

const recurrenceClient = createPrivateClient();

const checkoutService = {
  getCheckoutUrl: (msisdn: string, payload: CheckoutSessionPayload) =>
    privateApi.post(`/v2/customers/${msisdn}/smartcheckout/url`, payload),

  // Abre a sessão de checkout para o cliente gerenciar (alterar ou cancelar) a
  // recarga programada que já tem. Não leva body: o msisdn vai na URL e o
  // channel no header, pelo interceptor. Vai pelo privateApi mesmo, e não pelo
  // recurrenceClient: é ação primária do cliente, então um 401 aqui significa
  // sessão morta de verdade e o logout é o comportamento certo.
  createRecurrenceSession: (msisdn: string) =>
    privateApi.post(`/customers/${msisdn}/smartcheckout/recurrence/url`, null),

  syncRecharge: (msisdn: string, correlationId: string) =>
    privateApi.get(`/customers/${msisdn}/recharges/${correlationId}/checkout`),

  // Status da adesão à recarga programada aceita dentro do checkout. Usa o
  // mesmo correlationId da recarga — é o único identificador que o checkout
  // devolve no evento terminal.
  //
  // Vai pelo recurrenceClient, e não pelo privateApi, porque é consulta
  // secundária: um 401 aqui dispararia o interceptor de logout e expulsaria o
  // cliente da tela de sucesso de uma recarga que já foi concluída.
  //
  // `retries: 0` desliga o axios-retry só aqui. O cliente compartilhado retenta
  // GET em qualquer 5xx, e o 504 desta rota não é instabilidade: é o BFF
  // desistindo de esperar o recharge-service depois de 20s. Retentar paga 20s
  // por tentativa pela mesma resposta — em produção (07/10) isso empurrou a
  // linha de "em processamento" para 40s depois de a tela de sucesso já estar
  // na frente do cliente, que é o mesmo que nunca aparecer.
  syncRecurrence: (msisdn: string, correlationId: string) =>
    recurrenceClient.get(
      `/customers/${msisdn}/recharges/recurrence/result/${correlationId}`,
      { 'axios-retry': { retries: 0 } },
    ),
};

export default checkoutService;
